import React from 'react'
const timeline = [
  {
    year: "2022",
    title: "Foundation of Web Development Expertise",
    desc:
      "Web X Secure started its journey by mastering modern web technologies including HTML, CSS, JavaScript and responsive UI/UX design. This phase focused on building strong frontend development fundamentals and scalable web architecture understanding.",
    side: "left",
  },
  {
    year: "2023",
    title: "Freelance Projects & Client Growth",
    desc:
      "In 2023, Web X Secure began delivering real-world client projects including business websites, React applications and WordPress solutions. The focus was on performance, SEO optimization and modern UI development.",
    side: "right",
  },
  {
    year: "2024",
    title: "Training, Mentorship & Technical Expansion",
    desc:
      "Web X Secure expanded into technical training and mentorship programs covering web development, UI/UX design and cybersecurity fundamentals while working with multiple clients across different industries.",
    side: "left",
  },
  {
    year: "2025",
    title: "Internship & Full Stack Development Growth",
    desc:
      "The company became a recognized technical internship provider, delivering real industry projects using React, Node.js, MongoDB and AI-powered solutions for students and startups.",
    side: "right",
  },
  {
    year: "2026",
    title: "Digital Agency & Global Expansion Vision",
    desc:
      "Web X Secure is evolving into a full digital transformation agency offering UI/UX design, SaaS development, digital marketing and branding services for global businesses.",
    side: "left",
  },
];

function AboutTimeline() {
  return (
  
    <section className="relative py-16 px-4 sm:px-6 lg:px-16 overflow-hidden bg-[#f8f8f8] dark:bg-[#050505] text-gray-900 dark:text-white">

      {/* BACKGROUND GLOW */}
      <div className="absolute top-0 left-0 w-[300px] sm:w-[500px] h-[300px] sm:h-[500px] bg-primary/10 blur-[120px] sm:blur-[140px] rounded-full"></div>
      <div className="absolute bottom-0 right-0 w-[300px] sm:w-[500px] h-[300px] sm:h-[500px] bg-orange-300/10 blur-[120px] sm:blur-[140px] rounded-full"></div>

      {/* GRID */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(0,0,0,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(0,0,0,0.03)_1px,transparent_1px)] dark:bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:60px_60px]"></div>

      {/* TIMELINE */}
      <div className="relative max-w-5xl mx-auto">

        <div className="hidden md:block absolute left-1/2 transform -translate-x-1/2 w-[2px] h-full bg-gray-300 dark:bg-gray-700"></div>

        {timeline.map((item, index) => {
          const isLeft = item.side === "left";

          return (
            <div key={index} className="flex flex-col md:flex-row items-center mb-14">

              <div className="w-full md:w-1/2 md:pr-10 md:text-left">
                {isLeft && (
                  <div className="bg-white dark:bg-[#111] p-6 rounded-xl shadow-lg border border-gray-200 dark:border-gray-800">
                    <h3 className="text-primary font-semibold text-lg">{item.year}</h3>
                    <h4 className="font-bold text-lg mt-1">{item.title}</h4>
                    <p className="text-sm mt-2 text-gray-600 dark:text-gray-300">
                      {item.desc}
                    </p>
                  </div>
                )}
              </div>

              <div className="hidden md:flex w-4 h-4 bg-primary rounded-full border-4 border-white dark:border-black z-10 my-4 md:my-0"></div>

              <div className="w-full md:w-1/2 md:pl-10 md:text-left">
                {!isLeft && (
                  <div className="bg-white dark:bg-[#111] p-6 rounded-xl shadow-lg border border-gray-200 dark:border-gray-800">
                    <h3 className="text-primary font-semibold text-lg">{item.year}</h3>
                    <h4 className="font-bold text-lg mt-1">{item.title}</h4>
                    <p className="text-sm mt-2 text-gray-600 dark:text-gray-300">
                      {item.desc}
                    </p>
                  </div>
                )}
              </div>

            </div>
          );
        })}
      </div>
    </section>
  )
}

export default AboutTimeline
